import React from 'react';
import {
    Typography,
    Stack,
    TextField,
    Button,
    Select,
    Grid,
    InputLabel,
    MenuItem,
    Autocomplete,
    Checkbox,
    ListItemText
} from '@mui/material';
import { CountryList } from 'Services/CountryService';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { BundleStatusList, BundleTypeList } from './BundleService';
import * as BundleApi from './BundleApi';
import moment from 'moment';

export default function BundleEditView({ bundle, onClose }) {
    const editBundleForm = useForm({
        defaultValues: {
            statusCode: 'INPROGRESS',
            bundleName: '',
            validStartDate: moment().toISOString(),
            validEndDate: moment().add(1, 'year').toISOString(),
            countryList: [],
            heroProductIdList: bundle.heroProducts?.map(p => ({ id : p.productId, label : p.name })) || [],
            ...bundle,
        },
    });
    const [productList, setProductList] = React.useState([]);
    // const [mappedProductList, setMappedProductList] = React.useState({})

    React.useEffect(() => {
        (async () => {
            const data = await BundleApi.fetchProductList() || [];
            setProductList(data);
            // const mapdata=data.reduce((accu, p) => { 
            //     if (p.id) accu[p.id] = p; 
            //     return accu }, {});
            // console.log({mapdata})
            // setMappedProductList(mapdata);
        })();
    }, []);    
    const saveBundle = async () => {
        await editBundleForm
            .handleSubmit(onFormSubmit, onFromError)()
            .catch((err) => {
                alert('Save data error.  CHeck console for details.');
                console.error('Save data error', err);
            })
    };

    async function onFormSubmit(formData) {
        const submitData = { ...formData };
        try {
            if ((submitData.bundleType === 'HERO' || submitData.bundleType === 'GROUP') && submitData.heroProductIdList?.length) {
                submitData.heroProducts = await Promise.all(submitData.heroProductIdList.map(async option => {
                    const product = await BundleApi.getProductById(option?.id);
                    return BundleApi.mapProductToHero(product);
                }));
            }
            delete submitData.heroProductIdList;
            console.log('HERO', { submitData })
    

            if (bundle.id) {
                const responseData = await BundleApi.saveBundle(submitData);
                onClose(responseData);
            } else {
                const responseData = await BundleApi.saveNewBundle(submitData);
                onClose(responseData);
            }
        } catch (error) {
            console.warn('saveBundle failed : ', { error });
        }
    }

    async function onFromError(errors) {
        alert('Form data validation error.  Check console for details.');
        console.log('Form validation error ', errors);
    }

    function saveClicked() {
        saveBundle();
    }


    const watchBundleType = editBundleForm.watch('bundleType', '');

    return (
        <FormProvider {...editBundleForm}>
            <Stack direction="column" sx={{ m: 12 }} spacing={4}>
                <Typography variant="h2">Bundle Details</Typography>
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                    <Grid item xs={4}>
                        <InputLabel id="bundleName-label">Bundle Name</InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <Controller
                            name="bundleName"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <TextField id="bundleName" variant="outlined" fullWidth error={!!editBundleForm?.formState?.errors?.bundleName}
                                 {...field} />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel id="bundleCountry-label">Location</InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <Controller
                            name="countryList"
                            rules={{ required : true}}
                            render={({ field }) => (
                                <Select {...field} fullWidth id="country" labelId="country-label" multiple           renderValue={(selected) => selected.join(', ')} error={!!editBundleForm?.formState?.errors?.countryList}
                                >
                                    {CountryList.map((c) => (
                                        <MenuItem value={c.code}>
                                            <Checkbox checked={field.value.indexOf(c.code) > -1} />
                                            <ListItemText primary={c.display} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel id="description-label">Description</InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <Controller
                            name="description"
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    labelId="descripotion-label"
                                    id="descripotion"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    defaultValue=""
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel id="bundleStatus-label">Status</InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <Controller
                            name="statusCode"
                            render={({ field }) => (
                                <Select {...field} fullWidth id="statusCode" labelId="statusCode-label">
                                    {BundleStatusList.map((c) => (
                                        <MenuItem value={c.code}>{c.label}</MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel>Validity Start Date</InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <Controller
                            name="validStartDate"
                            render={({ field }) => <TextField variant="outlined" fullWidth {...field} />}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel>Validity End Date</InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <Controller
                            name="validEndDate"
                            render={({ field }) => <TextField variant="outlined" fullWidth {...field} />}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel id="bundleType-label">Type</InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <Controller
                            name="bundleType"
                            rules={{ required: true }}
                            render={({ field }) => (
                                <Select {...field} fullWidth id="bundleType" labelId="bundleType-label" {...field} error={!!editBundleForm?.formState?.errors?.bundleType}>
                                    {BundleTypeList.map((c) => (
                                        <MenuItem value={c.code}>{c.label}</MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </Grid>
                </Grid>
                {!!(watchBundleType === 'HERO' || watchBundleType === 'GROUP') && (
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                        <Grid item xs={4}>
                            <InputLabel id="bundleType-label">Connection</InputLabel>
                        </Grid>

                        <Grid item xs={8}>
                            <Controller
                                name="heroProductIdList"
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        multiple
                                        disablePortal
                                        id="combo-box-demo"
                                        options={productList.map(p => ({ label : p.name, id : p.id  }) )}
                                        sx={{ width: 300 }}
                                        fullWidth
                                        autoHighlight
                                        renderInput={(params) => (
                                            <TextField {...params} label="Product/Group" fullWidth />
                                        )}
                                        getOptionLabel={option => option.label}
                                        onChange={(e, data) => {
                                            console.log('change ', { data })
                                            field.onChange(data);
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                )}

                <Stack direction="row" justifyContent="flex-end" spacing={8} m={4}>
                    <Button variant="contained" color="primary" onClick={saveClicked}>
                        Save
                    </Button>
                </Stack>
            </Stack>
        </FormProvider>
    );
}
